const prefix = 'data-table-body-cell';

export const i18n = {
    copied: {
        id: `${prefix}.copied`,
        defaultMessage: 'Copied!',
    },
    clickToCopy: {
        id: `${prefix}.clickToCopy`,
        defaultMessage: 'Click to copy',
    },
} as const;
